/*
 * Botão "Esvaziar carrinho": zera todas as linhas com /cart/update.js e publica o mesmo evento
 * cartUpdate do tema, que re-renderiza o drawer, a página do carrinho e o contador.
 */
if (!customElements.get('cart-clear')) {
  customElements.define(
    'cart-clear',
    class CartClear extends HTMLElement {
      constructor() {
        super();

        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('button');
        this.button?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      async onClick() {
        if (this.button.getAttribute('aria-busy') === 'true') return;
        if (!window.confirm(this.dataset.confirm)) return;

        this.button.setAttribute('aria-busy', 'true');

        try {
          const cart = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
          const updates = Object.fromEntries(cart.items.map((item) => [item.key, 0]));

          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));

          const response = await fetch(theme.routes.cart_update_url, {
            ...theme.utils.fetchConfig(),
            body: JSON.stringify({ updates, sections })
          });
          const parsedState = await response.json();

          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || response.statusText);
          }

          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-clear', cart: parsedState });
        }
        catch (error) {
          console.error(error);
          this.button.removeAttribute('aria-busy');
          window.alert(this.dataset.error);
        }
      }
    }
  );
}
